<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>资讯管理/订单管理</span>
			</div>
			<div>
				<el-form
					:inline="true"
					:model="searchInfo"
					class="demo-form-inline margin_top_20 margin_left_20"
				>
					<el-form-item label="活动id">
						<el-input
							class="custom_input_170"
							v-model="searchInfo.activityid"
							placeholder=""
						>
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态" prop="type">
						<!-- 订单状态:1-已完成下单;2-申请退费；3-退费完成；4-支付中 -->
						<el-select v-model="searchInfo.status" placeholder="">
							<el-option label="已支付" value="1"> </el-option>
							<el-option label="申请退费" value="2"> </el-option>
							<el-option label="退费完成" value="3"> </el-option>
							<el-option label="支付中" value="4"> </el-option>
							<el-option label="取消支付" value="5"> </el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import { searchMixin } from "@/utils/searchMixin.js";
import { ticketlists } from "@/api/article";
export default {
	mixins: [searchMixin],
	components: { tablec },
	name: "",
	data() {
		return {
			title: "活动新增",
			tableData: [],
			total: 0,
			searchInfo: {
				page: 1,
				pageSize: 10,
				activityid: "",
				status: "",
			},
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		getDataList() {
			ticketlists(this.searchInfo)
				.then((res) => {
					if (res.code == 200) {
						this.tableData = res.data.list;
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped></style>
